"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Form = _interopRequireDefault(require("./Form"));
var _List = _interopRequireDefault(require("./List"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Addresses = _ref => {
  let {
    buttonLabel,
    buttonRef,
    lang,
    selected,
    selectable = false,
    type,
    onSelect,
    onSubmit
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-addresses"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "new",
    element: /*#__PURE__*/_react.default.createElement(_Form.default, {
      buttonLabel: buttonLabel,
      buttonRef: buttonRef,
      lang: lang,
      type: type,
      onSubmit: onSubmit
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "edit/:addressID",
    element: /*#__PURE__*/_react.default.createElement(_Form.default, {
      buttonLabel: buttonLabel,
      buttonRef: buttonRef,
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    index: true,
    element: /*#__PURE__*/_react.default.createElement(_List.default, {
      lang: lang,
      selected: selected,
      selectable: selectable,
      onSelect: onSelect
    })
  })));
};
var _default = exports.default = Addresses;